'use strict'
const _ = require('lodash')
import moment from 'moment'
import * as dot from 'dot-object';
import scontriniService from './scontriniService'
import prodottiService from './prodottiService'

function getTotaleProdotti(r) {
  let qta = 0
  let prezzo = 0
  for (let i = r.length - 1; i >= 0; i--) {      
    let riga = r[i]
    if (['prodotto', 'reparto'].includes(riga.tipo) && parseFloat(riga.quantita || 0) > 0) {
      let sconto = 0
      let abbuono = 0          
      if (riga.sconto) {
        sconto += parseFloat(riga.sconto.prezzo)
      }
      if (riga.abbuono) {
        abbuono += parseFloat(riga.abbuono.prezzo)
      }
      qta += parseFloat(riga.quantita)
      prezzo += (parseFloat(riga.prezzo) + sconto + abbuono)
    }
  }
  return { qta, totale: prezzo}
}

// Allineata a getScontiScontrino di mol_server_v2 (analysis.service.js), usata dalle dashboard del backoffice:
// scontoSub/abbuonoSub hanno valore positivo e riducono il totale, gli arrotondamenti hanno già il segno
function getScontiScontrino(r, s) {
  let scontoSub = 0
  let maggiorazioniSub = 0
  let locSub = 0
  let abbuonoPerEuro = 0
  try {
    let item = r.find(x => x.tipo === 'scontoSub')
    scontoSub += item ? Math.abs(parseFloat(item.valore)) : 0
    locSub += item ? Math.abs(parseFloat(item.valore)) : 0

    item = r.find(x => x.tipo === 'abbuonoSub')
    scontoSub += item ? Math.abs(parseFloat(item.valore)) : 0
    locSub += item ? Math.abs(parseFloat(item.valore)) : 0

    item = r.find(x => x.tipo === 'arrotondaDifetto')
    scontoSub += item ? -parseFloat(item.valore) : 0
    locSub += item ? -parseFloat(item.valore) : 0 // valore negativo: riduce il totale

    item = r.find(x => x.tipo === 'arrotondaEccesso')
    maggiorazioniSub += item ? parseFloat(item.valore) : 0
    locSub += item ? -parseFloat(item.valore) : 0 // valore positivo: aumenta il totale

    item = r.find(x => x.tipo === 'subtotale')
    let subtotale = item ? parseFloat(item.prezzo) : 0
    if (subtotale === 0 && locSub !== 0) {
      subtotale = getTotaleProdotti(r).totale
    }
    abbuonoPerEuro = subtotale > 0 ? -locSub / subtotale : 0
  } catch(err) {
    console.log(s._id)
  }
  return {scontoSub, maggiorazioniSub, abbuonoPerEuro}
}

async function flatRigheScontini(base, filtro, istanzaDb) {
  let statistica = []
  const start = moment(filtro.start, 'YYYYMMDDHHmmss').toISOString()
  const end = moment(filtro.end, 'YYYYMMDDHHmmss').toISOString()
  let scontrini = await scontriniService.elencoScontriniPerData(base, start, end, -1, istanzaDb) // nessun limite sul numero degli scontrini
  if (!Array.isArray(scontrini)) {
    return statistica
  }
  scontrini = scontrini.filter(x => x.stato === 'chiuso' || x.stato === 'non stampato') // tolgo scontrini annullati e aperti ma considero quelli con stampante in errore
  let sortScontrini = _.sortBy(scontrini, [function(o) { return o._if; }]).reverse()
  for (let s of sortScontrini) {
    let r = (s.righe || []).filter(x => x && x.tipo) // elimina le righe nulle
    const {scontoSub, maggiorazioniSub, abbuonoPerEuro} = getScontiScontrino(r, s)

    for (let i = r.length - 1; i >= 0; i--) {
      try {
        let riga = r[i]
        if (['prodotto', 'reparto'].includes(riga.tipo) /* && parseFloat(riga.quantita || 0) > 0 */) {
          let sconto = 0
          let abbuono = 0          
          if (riga.sconto) {
            sconto += parseFloat(riga.sconto.prezzo)
            delete riga.sconto
          }
          if (riga.abbuono) {
            abbuono += parseFloat(riga.abbuono.prezzo)
            delete riga.abbuono
          }
          let qta = parseFloat(riga.quantita)
          let prezzo = parseFloat(riga.prezzo) + sconto + abbuono
          prezzo = prezzo * (1 + abbuonoPerEuro)

          const stat = {
            data: s._id,
            quantita: qta,
            codice: riga.codice,
            valore: prezzo 
          }
          statistica.push(stat)          
        }
      } catch (err) {
        console.log('errore su', r, s._id)
      }
    }
  }
  return statistica
}

const dashboardVendutoPeriodoV2 = async function(base, filtro, tipoRiepilogo, tipoDashboard, istanzaDb) {
  try {
    let lenChiave = 10
    if (tipoRiepilogo === 'year') { // mettere switch se più opzioni
      lenChiave = 7
    }

    let statistica = await flatRigheScontini(base, filtro, istanzaDb)
    let risultato = _.reduce(statistica, function(result, value, key, collection) {
      let chiave = value.data.substr(0, lenChiave)
      let prec = result[chiave] || { k: chiave, q: 0, v: 0 }
      prec.q += value.quantita
      prec.v = +(prec.v + value.valore).toFixed(2)
      result[chiave] = prec
      return result
    }, {})

    // I giorni (o i mesi) senza vendite compaiono a 0, così il periodo ha sempre tutti i giorni
    const unita = lenChiave === 7 ? 'month' : 'day'
    const formato = lenChiave === 7 ? 'YYYY-MM' : 'YYYY-MM-DD'
    const giorno = moment(filtro.start, 'YYYYMMDDHHmmss').startOf(unita)
    const ultimo = moment.min(moment(filtro.end, 'YYYYMMDDHHmmss'), moment()).startOf(unita) // niente giorni futuri
    while (giorno.isSameOrBefore(ultimo)) {
      const chiave = giorno.format(formato)
      if (!risultato[chiave]) {
        risultato[chiave] = { k: chiave, q: 0, v: 0 }
      }
      giorno.add(1, unita)
    }
    return _.sortBy(Object.values(risultato), [function(o) { return o.k; }])

  } catch (error) {
    console.log(error)
    // winston.error(`dashboardVendutoPeriodo_v2 - Errore: ${error}`);
  }
}

const dashboardVendutoPeriodoGruppoV2 = async function(base, filtro, tipoRiepilogo, tipoDashboard, gruppo, istanzaDb) {
  try {
    let lenChiave = 10
    if (tipoRiepilogo === 'year') { // mettere switch se più opzioni
      lenChiave = 7
    }

    let statistica = await flatRigheScontini(base, filtro, istanzaDb)

    let ids = _.uniq(statistica.map(x => x.codice))
    let prodotti = []
    let start = 0
    let count = 1000
    let end = count
    do {
      const toRead = ids.slice(start, end)
      const newProd = await prodottiService.getProdottiByIds(base, toRead, 0, istanzaDb)
      prodotti = _.concat(prodotti, newProd)
      start = end
      end = start + count
    } while (start < ids.length)

    let sortScontrini = _.sortBy(statistica, [function(o) { return o.data; }])
    let risultato = _.reduce(sortScontrini, function(result, value, key, collection) {
      let prodotto = prodotti.find(x => x._id === value.codice)
      let chiave = value.data.substr(0, lenChiave)
      if (prodotto) {
        chiave = (dot.pick(gruppo, prodotto) || '').toUpperCase()
        if (!chiave) {
          chiave = prodotto.descrizione.toUpperCase() // 'NON DEFINITO'
        }
        chiave = String(chiave)
      } else {
        chiave = 'NON DEFINITO'
      }

      let prec = result[chiave] || { k: chiave, q: 0, v: 0 }
    
      prec.q += value.quantita
      prec.v = +(prec.v + value.valore).toFixed(2)
      result[chiave] = prec 
      return result
    }, {})
    return _.sortBy(Object.values(risultato), [function(o) { return o.v; }]).reverse()
  } catch (error) {
    // winston.error(`dashboardVendutoPeriodoGruppo_v2 - Errore: ${error}`);
  }
}

const dashboardVendutoUltimo = async function(base, filtro, tipoRiepilogo, tipoDashboard, istanzaDb) {
  try {
    let lenChiave = 10
    if (tipoRiepilogo === 'year') { // mettere switch se più opzioni
      lenChiave = 7
    }
    let statistica = await flatRigheScontini(base, filtro, istanzaDb)
    let sortStatistica = _.sortBy(statistica, [function(o) { return o.data; }])
    let lastM = _.last(sortStatistica)
    let risultato = {
        k: lastM.data.substr(0, lenChiave),
        q: lastM.quantita,
        v: lastM.valore,
        d: lastM.data.substr(0, 19)
      }
    return risultato
  } catch (error) {
    // winston.error(`dashboardVendutoUltimo - Errore: ${error}`);
  }
}

export default {
  dashboardVendutoUltimo,
  dashboardVendutoPeriodoV2,
  dashboardVendutoPeriodoGruppoV2
}